export const successAudio = new Audio('/sounds/scan-success.mp3')
export const failAudio = new Audio('/sounds/scan-fail.mp3')
